module.exports = __webpack_public_path__ + "img/photo.4564713f.svg";